import {useEffect} from 'react';
import {useError} from 'hooks/useError';
import Item from 'components/Error/Item'
import SpinnerBootrap from 'components/SpinnerBootrap';

function Error() {
 const {error, getOneError, loading} = useError()
 const id = window.location.pathname.split('/')[2];


 useEffect(() => {
    (async () => {
        await getOneError({id});
    })()
    // eslint-disable-next-line
 },[])
return (
   <div className="container">
    <h1 className="text-center my-4">Historial</h1> 
    {!loading
    ?
    <>
        <div className="row justify-content-center align-item-center my4">
            {Object.keys(error).length 
                ?
                <ul className="list-group">
                    <li className="list-group-item d-flex justify-content-between align-items-center"><strong>Comando:</strong> <span>{error.comando}</span></li>
                    <li className="list-group-item d-flex justify-content-between align-items-center"><strong>Identificador:</strong> <span>{error.identificador}</span></li>
                    <li className="list-group-item d-flex justify-content-between align-items-center"><strong>Mensaje:</strong> <span style={{"textAlign": "right"}}>{error.mensaje}</span></li>
                </ul>       
                : 
                ''
            } 
        </div>
        <div className="mt-4">
            <div className="table-responsive rounded-3" style={{border: '1px solid black'}}>
                <table className="table">
                <thead>
                    <tr>
                        <th scope="col" className="text-center">#</th>
                        <th scope="col" className="text-center">Estado</th>
                        <th scope="col" className="text-center">¿Quién te asigno?</th>
                        <th scope="col" className="text-center">Usuario Asignado</th>
                        <th scope="col" className="text-center">Mensaje</th>
                        <th scope="col" className="text-center">Fecha</th>
                        <th scope="col" className="text-center">Hora</th>
                    </tr>
                </thead>
                <tbody>
                {/* <pre>
                {JSON.stringify(error, 0 ,2)}
                </pre> */}
                {Object.keys(error).length 
                    ?
                    error.historial.length ? 
                    error.historial.map((hist, i) => <Item 
                        key={hist._id}  
                        i={i} 
                        hist={hist} 
                    />) 
                    :
                    <tr>
                        <td colSpan="5">Sin datos</td>
                    </tr>
                    :
                    <tr>
                        <td colSpan="5">Sin historial</td>
                    </tr>
                }
                </tbody>
                </table>
            </div>
        </div>
    </>
    : 
    <SpinnerBootrap></SpinnerBootrap>
    }
   </div>

 )
}

export default Error
